import { atom } from "recoil";
import { IUsuario } from "../../commons/types/usuatios";

export const usuarioOneAtom = atom<IUsuario[]>({
  key: 'usuarioOne',
  default: [] as IUsuario[],
});

